const DEFAULT_MOI_METHODS = {
  all: {
    damage_assessment: {
      desc: 'Damage Assessment',
      description: 'Send a field adjuster or appraiser to inspect the loss and quantify the damage.',
      coverages: [],
      expertises: ['field_adjuster', 'appraiser'],
    },
    fraud_detection: {
      desc: 'Fraud Detection',
      description: 'Refer the claim for investigation where the circumstances suggest misrepresentation or fraud.',
      coverages: [],
      expertises: ['forensics', 'investigator', 'siu'],
    },
    legal_services: {
      desc: 'Legal Services',
      description: 'Engage an attorney or legal service to advise on or represent the claim.',
      coverages: [],
      expertises: ['legal_services', 'attorney'],
    },
    medical_services: {
      desc: 'Medical Services',
      description: 'Refer the claimant for medical examination, treatment review or an independent medical opinion.',
      coverages: [],
      expertises: ['medical_services', 'medical_center', 'medical_examiner'],
    },
    outsourcing: {
      desc: 'Outsourcing',
      description:
        "Hand the claim, or part of it, to an external adjusting firm to handle on the organization's behalf.",
      coverages: [],
      expertises: ['claim_adjusting'],
    },
    other: {
      desc: 'Other',
      description:
        'Any inspection or service that none of the other methods covers; describe the request in the assignment itself.',
      coverages: [],
      expertises: ['other'],
    },
    xactanalysis: {
      desc: 'XactAnalysis',
      description:
        'Send the assignment to XactAnalysis so a network contractor or appraiser can produce an Xactimate estimate.',
      expertises: ['appraiser', 'engineer', 'contractor', 'field_adjuster'],
    },
  },
  auto_claim: {
    body_shop: {
      desc: 'Body Shop',
      description: 'Send the vehicle to a body shop for a repair estimate and the repair work.',
      coverages: [],
      expertises: ['approved_body_shop', 'unapproved_body_shop'],
    },
    tow_lot: {
      desc: 'Tow Lot',
      description: 'Arrange recovery and storage of the vehicle at a tow lot, and inspection while it is held there.',
      coverages: [],
      expertises: ['tow_lot'],
    },
    car_rental: {
      desc: 'Car Rental',
      description: 'Arrange a replacement vehicle for the claimant while theirs is off the road.',
      coverages: [],
      expertises: ['car_rental'],
    },
    windscreen: {
      desc: 'Windscreen',
      description: 'Repair or replace vehicle glass through a windscreen specialist.',
      coverages: [],
      expertises: ['windscreen'],
    },
    road_services: {
      desc: 'Road Services',
      description:
        'Dispatch roadside assistance to the vehicle for a jump start, wheel change, fuel delivery or on-scene recovery.',
      coverages: [],
      expertises: ['road_services'],
    },
  },
  home_claim: {
    mitigation_services: {
      desc: 'Mitigation Services',
      description:
        'Dispatch a leak-detection or mitigation crew to stop ongoing damage and dry the property out before repairs begin.',
      coverages: [],
      expertises: ['leak_detection_expert', 'mitigation_services'],
    },
    damage_assessment: {
      description:
        'Send an engineer or contractor to inspect the property, establish the cause of loss and quantify the damage.',
      expertises: ['engineer', 'contractor'],
    },
  },
} as const;

export default DEFAULT_MOI_METHODS;
